/**
 * Mode
 *
 * @author Kazuhiko Arase
 */
export var Mode;
(function (Mode) {
    /**
     * number
     */
    Mode[Mode["MODE_NUMBER"] = 1] = "MODE_NUMBER";
    /**
     * alphabet and number
     */
    Mode[Mode["MODE_ALPHA_NUM"] = 2] = "MODE_ALPHA_NUM";
    /**
     * 8bit byte
     */
    Mode[Mode["MODE_8BIT_BYTE"] = 4] = "MODE_8BIT_BYTE";
    /**
     * KANJI
     */
    Mode[Mode["MODE_KANJI"] = 8] = "MODE_KANJI";
})(Mode || (Mode = {}));
//# sourceMappingURL=Mode.js.map